import { INTERNAL_TOKEN_NAME } from "../redux/constants";

const DISABLE_ALL_PROCESS_PRESERVATION = true; // Atif requested disabling all for now

// =================================
// Basic Environmental Detection ===
// =================================

export const isInternal = function () {
  return JSON.parse(sessionStorage.getItem(INTERNAL_TOKEN_NAME));
};

export const isLocal = function () {
  return window.location.hostname.includes("localhost");
};

export const isDev = function () {
  return isLocal() || window.location.hostname.includes(".t.");
};

export const isProd = function () {
  return !isDev();
};

export const allowProcessPreservation = (function () {
  if (!isLocal() && DISABLE_ALL_PROCESS_PRESERVATION) {
    return false;
  }

  return {
    createDataset: isLocal(),
    uploadDataset: isLocal(),
    createCampaignAdHoc: isLocal(),
    createCampaignTemplate: isLocal(),
  };
})();
